const AS = require('@react-native-async-storage/async-storage').default;

exports._getItem = AS.getItem;
exports._setItem = AS.setItem;
exports._removeItem = AS.removeItem;
exports._clear = AS.clear;
exports._getAllKeys = AS.getAllKeys;
